const ampRegex = /&amp;/g;
const ltRegex = /&lt;/g;
const gtRegex = /&gt;/g;
const quotRegex = /&quot;/g;
const aposRegex = /&apos;/g;

/**
 * Converts XML-escaped characters to real ones
 * @param {string} str 
 */
const unEscapeXml = (str) => {
    let escaped = str;
    escaped = escaped.replace(ampRegex, '&');
    escaped = escaped.replace(ltRegex,  '<');
    escaped = escaped.replace(gtRegex,  '>');
    escaped = escaped.replace(quotRegex,'"');
    escaped = escaped.replace(aposRegex,"'");
    return escaped;
}

export default unEscapeXml;